import { IReactChildrenProps } from '@/interfaces/IReactChildren';

export default function AuthContainer({ children }: IReactChildrenProps) {
	return (
		<div className="w-full flex justify-center px-1 md:px-8 py-8">
			{children}
		</div>
	);
}
